module.exports = __webpack_public_path__ + "img/horizontal_6_2_6000.f1890b3e.png";